import db from "../database";
import { fetchTablesStatusData } from "../services/syncServices";
import { tracePreparedBill } from "./preparedBillRecovery";

/**
 * TIC-11390 round 4: does the SERVER still hold an open order on a table this device shows as free?
 *
 * HMRES01 9-11 Oct: after Prepare Bill, a device closed the bill's session on its own copy only
 * (force-close when another order on the table completed), so the table looked free there. Waiter
 * devices never receive the prepared bill itself (POS_ORDER_UPSERT is skipped for a Waiter POS),
 * so the next tap started a brand-new order — one Mineral Water — and the prepared bill was never
 * paid. Ten Himayathnagar sessions are still open on the server (04-11 Oct).
 *
 * True only when the server reports an open order for the table AND this device has not itself
 * completed (paid) that order — a locally paid order whose CO has not reached the server yet must
 * not be reopened. Online-only tenants (disableOfflineBilling "Y") only, the same gate handleTable
 * uses for its server read. Never throws: any failure answers false, i.e. today's behaviour.
 */
export const serverHasOpenOrderOnTable = async (cwrFbTableId, posConfig) => {
  try {
    if (!cwrFbTableId || posConfig?.disableOfflineBilling !== "Y") return false;
    const status = await fetchTablesStatusData(cwrFbTableId);
    const row = Array.isArray(status) ? status[0] : null;
    if (!row?.orderId || !row?.orderStatus || ["CO", "CL"].includes(row.orderStatus)) return false;
    const local = await db.fbOrderData.where("fbOrderId").equals(row.orderId).first();
    if (local?.fbOrderStatus === "CO") return false;
    tracePreparedBill("new-order-blocked-server-open-order", { tableId: cwrFbTableId, serverOrderId: row.orderId, serverStatus: row.orderStatus, localStatus: local?.fbOrderStatus || null });
    return true;
  } catch {
    return false;
  }
};
